document.addEventListener('DOMContentLoaded', () => {
    // slick default setting
    let defaulsettings = {
        loop: true,
        speed: 700,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            nextEl: '.swiper-prev',
            prevEl: '.swiper-next'
        },
        autoplay: {
            delay: 5000,
            disableOnInteraction: false
        }
    };

    // start slider default
    let allSwipper =[];

    document.querySelectorAll('.swiper-slider').forEach((element,i) => {

        let swiperConfig = element.dataset.swiper ? JSON.parse(element.dataset.swiper) : defaulsettings;
        element.setAttribute(`data-swiper-${i}`,"");
        let swiper = new Swiper(`[data-swiper-${i}]`, swiperConfig);
        allSwipper[i] = swiper;

    });

    let topContentSlider = new Swiper('.top-content__slider',{
        loop: true,
        speed: 700,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        autoplay: {
            delay: 5000,
            disableOnInteraction: false
        }
    });

    let quadReviews = new Swiper('.reviews__slider',{
        loop: true,
        slidesPerView: 1,
        speed: 1000,
        navigation: {
            prevEl: '.reviews-prev',
            nextEl: '.reviews-next'
        },
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        }
    });

    let gallerySliderBig = new Swiper('.gallery-quad__slider-big',{
        speed: 1400,
        allowTouchMove: true,
        slidesPerView: 1,
        spaceBetween: 10,
        loop: true,
        breakpoints: {
            660: {
                slidesPerView: 2,
                allowTouchMove: false
            },
            1024:{
                slidesPerView: 3
            }
        },
        pagination: {
            el: '.gallery-quad-pagination',
        }
    });

    let gallerySliderSmall = new Swiper('.gallery-quad__slider-small',{
        speed: 800,
        slidesPerView: 3,
        spaceBetween: 10,
        loop: true,
        navigation: {
            prevEl: '.gallery-quad-prev',
            nextEl: '.gallery-quad-next'
        },
        breakpoints: {
            660: {
                slidesPerView: 2
            },
            1024:{
                slidesPerView: 3
            }
        }
    });

    if(document.querySelector('.gallery-quad__slider-small')){
        gallerySliderSmall.controller.control = gallerySliderBig;
    }

    let sliderQuad = new Swiper('.slider__slider',{
        speed: 1000,
        loop: true,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            prevEl: '.slider-prev',
            nextEl: '.slider-next'
        }
    });

    let sliderAwards = new Swiper('.slider-awards__slider',{
        speed: 1000,
        loop: true,
        slidesPerView: 1,
        spaceBetween: 200,
        navigation: {
            prevEl: '.slider-awards-prev',
            nextEl: '.slider-awards-next'
        },
        breakpoints: {
            660: {
                slidesPerView: 2,
                spaceBetween: 150
            },
            1024:{
                slidesPerView: 3,
                spaceBetween: 200
            }
        }
    });

    let sliderPortfolio = new Swiper('.portfolio__slider',{
        speed: 1400,
        slidesPerView: 1,
        spaceBetween: 10,
        breakpoints: {
            660: {
                slidesPerView: 3
            },
            1024:{
                slidesPerView: 4
            }
        },
        pagination: {
            el: '.portfolio-pagination',
        }
    });

    if(document.querySelector('.portfolio:not(.mobile)')){        
		let buttonsPortfolio = document.querySelectorAll('.portfolio__image');
		let allImagesActive = document.querySelectorAll('.portfolio__image-active');

		buttonsPortfolio.forEach((button)=>{
			button.addEventListener('click',()=>{
				let imgPosition = button.dataset.image;
				allImagesActive.forEach((img) => {
					img.classList.toggle('active', img.dataset.image === imgPosition);
				});
                sliderPortfolio.slideTo(imgPosition, 1400);
			})
		})
	}

    let sliderText = new Swiper('.slider-text__slider',{
        speed: 1000,
        loop: true,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            prevEl: '.slider-text-prev',
            nextEl: '.slider-text-next'
        }
    });

    let sliderHrztl = new Swiper('.slider-hrztl__slider',{
        speed: 1000,
        loop: true,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            prevEl: '.slider-hrztl-prev',
            nextEl: '.slider-hrztl-next'
        }
    });
    
});